import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import {IntegrationActions, IntegrationSection} from "../IntegrationDetailUi.jsx";
import StoredSecretInput from "../IntegrationFormInput/StoredSecretInput.jsx";

export default function SklikIntegrationForm({project, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let navigate = useNavigate();
    let [sklikSettings, setSklikSettings] = useState({
        'apiKey': '',
    });
    let {getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);
    let [buttonClicked, setButtonClicked] = useState(false);
    let [state, setDownloading, setResult, setError] = useDownloadState();

    useEffect(() => {
        if (!buttonClicked) {
            return;
        }

        // Reset error message
        setError(null);

        setButtonClicked(false);
        setDownloading(true);

        new ProjectIntegrationsApi(getAuthorityConfiguration())
            .sklikIntegration({
                projectId: project.id,
                integrationId: projectIntegration?.id ?? null,
                sklikIntegrationInput: sklikSettings,
            })
            .then((result) => {

                navigate('/project/' + project.id + '/settings/integrations?integrationId=' + result.id);
                resetCurrentUserProjects();

                if (projectIntegration === null) {
                    toast.success(t('created'));
                } else {
                    if (result.errors.length > 0) {
                        toast.success(t('saved-with-errors'));
                    } else {
                        toast.success(t('saved'));
                    }
                }

            })
            .catch(e => {
                et(e).then((message) => { if (message) toast.error(message); });
            })
            .finally(() => setDownloading(false));

    }, [buttonClicked]);

    const isButtonDisabled = projectIntegration === null && !sklikSettings.apiKey.trim();

    return (<LoadingComponent loading={state.downloading}>
        <IntegrationSection
            title={'Přístup k Skliku'}
            description={'API klíč je uložen jako citlivý údaj. Při úpravě ponechte pole beze změny, pokud nechcete uložený klíč nahradit.'}
        >
            <label className={'flex flex-col gap-1.5 text-sm font-medium text-slate-700 dark:text-slate-200'}>
                {t('api-key')}
                <StoredSecretInput
                    configured={projectIntegration?.apiKeyConfigured ?? false}
                    value={sklikSettings.apiKey}
                    onChange={(apiKey) => setSklikSettings((settings) => ({...settings, apiKey}))}
                />
            </label>
            <div className={'mt-5'}>
            <IntegrationActions>
                <Button
                    className={'button-primary'}
                    onClick={() => setButtonClicked(true)}
                    title={projectIntegration ? 'Uložit změny' : 'Vytvořit integraci'}
                    disabled={isButtonDisabled}
                >
                    {projectIntegration ? 'Uložit změny' : 'Vytvořit integraci'}
                </Button>
            </IntegrationActions>
            </div>
        </IntegrationSection>
    </LoadingComponent>);
}
